import { values } from './enums'

const _enum = {
  Clean: 0,
  CurrentSubmission: 1,
  PreviousSubmission: 2,
  FinalSubmission: 3
}

export const reportSubmissionGroupExportType = {
  enumName: 'ReportSubmissionGroupExportType',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportSubmissionGroupExportType.js